/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createShoppingCartFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ShoppingCart } from '../../../models/index.js';
// @ts-ignore
import { EventsRequestBuilderRequestsMetadata, type EventsRequestBuilder } from './events/index.js';
// @ts-ignore
import { type WithShoppingCartItemRequestBuilder, WithShoppingCartItemRequestBuilderNavigationMetadata, WithShoppingCartItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}
 */
export interface CartItemRequestBuilder extends BaseRequestBuilder<CartItemRequestBuilder> {
    /**
     * The events property
     */
    get events(): EventsRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.carts.item.item collection
     * @param shoppingCartId Gets or sets the ID of the shopping cart to be updated.
     * @returns {WithShoppingCartItemRequestBuilder}
     */
     byShoppingCartId(shoppingCartId: string) : WithShoppingCartItemRequestBuilder;
    /**
     * Delete an entire ShoppingCart by its unique identifier. Only administrators can use this endpoint.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Retrieve a shopping cart by its unique identifier.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ShoppingCart>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ShoppingCart | undefined>;
    /**
     * Delete an entire ShoppingCart by its unique identifier. Only administrators can use this endpoint.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Retrieve a shopping cart by its unique identifier.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CartItemRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CartItemRequestBuilderNavigationMetadata: Record<Exclude<keyof CartItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byShoppingCartId: {
        requestsMetadata: WithShoppingCartItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithShoppingCartItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["shoppingCartId"],
    },
    events: {
        requestsMetadata: EventsRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CartItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: CartItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: CartItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createShoppingCartFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
